<fury-page-layout mode="card">
    <fury-page-layout-header>
      <fury-breadcrumbs [@fadeInRight]  current="Block Email Id List"></fury-breadcrumbs>
    </fury-page-layout-header>
  
    <fury-page-layout-content [@fadeInUp]>
      <fury-list name='Block Email Id' [columns]="columns" (filterChange)="onFilterChange($event)">
        <div class="actions">
            <button class="create" type="button" mat-mini-fab color="primary" [routerLink]="['/settings/block-contact/add-block-emails']">
                <mat-icon>add</mat-icon>
              </button>
        </div>
        <table [dataSource]="dataSource" mat-table matSort>
            <!-- actions Column -->
            <ng-container matColumnDef="actions">
              <th *matHeaderCellDef class="actions-cell" mat-header-cell mat-sort-header>Actions</th>
              <td *matCellDef="let row;let i=index" class="actions-cell" mat-cell>
                <button type="button" mat-icon-button [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation()">
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                  <button mat-menu-item (click)="delete('delete', row?.blockedEmailId)">
                    <span>Delete</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef>Block Email Id</th>
              <td mat-cell *matCellDef="let element">
                  {{element?.email}}
              </td>
          </ng-container>
        <tr *matHeaderRowDef="visibleColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: visibleColumns;" class="clickable route-animations-elements" mat-row></tr>
          </table>
          <div *ngIf="!itemList" style="padding: 10px 0; text-align:center;">
            No data found.
          </div>
      </fury-list>
  
    </fury-page-layout-content>
  </fury-page-layout>
    
